import * as Yup from "yup";

export const paymentMethodSchema = Yup.object().shape({
  name: Yup.string()
    .required("Nome é obrigatório")
    .min(2, "Nome deve ter pelo menos 2 caracteres"),

  percentage_fee: Yup.number()
    .transform((value, originalValue) => {
      if (originalValue === undefined || originalValue === null)
        return undefined;
      const str = String(originalValue).trim();
      if (str === "") return undefined;
      // remove símbolo de porcentagem e espaços, aceita vírgula como decimal
      const cleaned = str.replace("%", "").replace(",", ".").trim();
      return cleaned === "" ? undefined : Number(cleaned);
    })
    .typeError("Taxa percentual deve ser um número")
    .required("Taxa percentual é obrigatória")
    .min(0, "Taxa não pode ser negativa")
    .max(100, "Taxa não pode ser maior que 100"),
});
